define('app/editor/dialogs/SaveReportDialogView',['require','./SaveDialogView','app/dashboard/DashboardWidgetTypes','app/app','app/config/strings','app/config/reportTypes','glu/util','glu/dialog','hbs!./SaveReportDialogView.hbs'],function(require) {
	'use strict';

	var SaveDialogView = require('./SaveDialogView'),
		WIDGET_TYPES = require('app/dashboard/DashboardWidgetTypes'),
		App = require('app/app'),
		strings = require('app/config/strings'),
		reportTypes = require('app/config/reportTypes'),
		_ = require('glu/util'),
		dialog = require('glu/dialog');

	var view = SaveDialogView.extend({

		dialogTitle: 'Save Report',

		getClass: function() {
			return 'modal-save-report';
		},

		template: require('hbs!./SaveReportDialogView.hbs'),

		ui: {
			$selectedDashboard: '.select-box',
			$copyFieldId: '#save-dialog-as-a-copy',
			$saveAsWidgetFieldId: '#chk-save-dialog-as-widget',
			$widgetTypeFieldId: '#save-dialog-widget-type'
		},

		events: {
			'change .select-box': 'checkDashboardSelection',
			'change #save-dialog-name': 'onChangeName',
			'keyup #save-dialog-name': 'onChangeName',
			'change #save-dialog-description': 'onChangeDesc',
			'keyup #save-dialog-description': 'onChangeDesc',
			'change #save-dialog-as-a-copy': 'onChangeAsCopy'
		},

		initialize: function() {
			this.selectSaveAs = this.options.saveAs;
			this.reportType = this.options.type;
		},

		onRender: function() {
			this.ui.$selectedDashboard.comboBox();
			this.validationMessage = '';
		},

		getName: function() {
			if (this.selectSaveAs) {
				return this.model.getName() + ' (copy)';
			}
			return this.model.getName();
		},

		getDescription: function() {
			return this.model.getDescription();
		},

		getDashboard: function() {
			return this.model.getDashboardId();
		},

		getAvailableWidgetType: function() {
			var self = this;
			var report = this.model;
			var widgetTypes = [];

			// if we can't render the report, don't allow the user to save the report.
			if (!this.model.canRenderReport()) {
				if (this.model.getVisualization() === 'pivot-table') {
					self.validationMessage = '<em>Save as a dashboard widget</em> option is not available for pivot tables.';
				} else {
					self.validationMessage = '<em>Save as a dashboard widget</em> option is not available because ' +
						self.model.getReasonForCannotRenderReport() + '. <strong>This report will be saved to the "Reports" tab of your dashboard.</strong>';
				}
				return widgetTypes;
			}

			// now present the user with the option to save as a widget that is appropriate for their
			// current visualization selection.
			switch (this.model.getVisualization()) {
				case 'bar-chart':
					widgetTypes.push({
						label: WIDGET_TYPES.BARCHART.label,
						value: WIDGET_TYPES.BARCHART.value,
						isSelected: report.getWidgetType() === WIDGET_TYPES.BARCHART.value
					});
					break;
				case 'stacked-bar-chart':
					widgetTypes.push({
						label: WIDGET_TYPES.STACKEDBARCHART.label,
						value: WIDGET_TYPES.STACKEDBARCHART.value,
						isSelected: report.getWidgetType() === WIDGET_TYPES.STACKEDBARCHART.value
					});
					break;
				case 'line-chart':
					widgetTypes.push({
						label: WIDGET_TYPES.LINECHART.label,
						value: WIDGET_TYPES.LINECHART.value,
						isSelected: report.getWidgetType() === WIDGET_TYPES.LINECHART.value
					});
					break;
				case 'scatter-plot':
					widgetTypes.push({
						label: WIDGET_TYPES.SCATTERPLOT.label,
						value: WIDGET_TYPES.SCATTERPLOT.value,
						isSelected: report.getWidgetType() === WIDGET_TYPES.SCATTERPLOT.value
					});
					break;
				case 'pie-chart':
					widgetTypes.push({
						label: WIDGET_TYPES.PIECHART.label,
						value: WIDGET_TYPES.PIECHART.value,
						isSelected: report.getWidgetType() === WIDGET_TYPES.PIECHART.value
					});
					break;
				case 'donut-chart':
					widgetTypes.push({
						label: WIDGET_TYPES.DONUT.label,
						value: WIDGET_TYPES.DONUT.value,
						isSelected: report.getWidgetType() === WIDGET_TYPES.DONUT.value
					});
					break;
				case 'table':
					// allow Top10 as a widget only
					if (this.model.hasTop10ListResults()) {
						widgetTypes.push({
							label: WIDGET_TYPES.TOP10.label,
							value: WIDGET_TYPES.TOP10.value,
							isSelected: report.getWidgetType() === WIDGET_TYPES.TOP10.value
						});
					} else {
						this.validationMessage = 'This report cannot be <em>saved as a dashboard widget</em> because a table must have exactly two columns to be saved as Top 10 widget.';
					}
					break;
				case 'pivot-table':
					this.validationMessage = '<em>Save as a dashboard widget</em> option is not available for pivot tables.';
					break;

			}

			return widgetTypes;
		},

		getWidgetType: function() {
			return this.$el.find(this.ui.$widgetTypeFieldId).attr('value');
		},

		dashboardOptions: function() {
			//find the available dashboards other than fixed that is bound to this domain
			var selected = App.dashboards.filter(function(d) {
				return ((d.get('dashboardType') === 'BASIC' || d.get('dashboardType') === 'CUSTOM') && d.get('owner') === App.user.getUsername());
			});

			var dashboardId = this.getDashboard();
			return selected.map(function(d) {
				return {
					value: d.get('id'),
					label: d.get('name'),
					isSelected: dashboardId === d.get('id')
				};
			});
		},

		checkDashboardSelection: function() {
			if (this.uigetDashboard() !== 'default') {
				this.ui.$selectedDashboard.parent().removeClass('has-error');
			} else {
				this.ui.$selectedDashboard.parent().addClass('has-error');
			}
		},

		isDashboardSelected: function() {
			if (this.uigetDashboard() !== 'default') {
				return true;
			}
			this.ui.$selectedDashboard.parent().addClass('has-error');
			return false;
		},

		save: function() {
			var self = this;
			if (this.isDashboardSelected() && this.isValid()) {
				this.model.set('saveInProgress', true, {
					silent: true
				});
				var imported = this.model.get('recentlyImported');
				this.model.set('recentlyImported', undefined, {
					silent: true
				});

				if (this.isSaveAsWidgetSelected()) {
					this.model.setWidgetType(self.getWidgetType());
				} else {
					this.model.setWidgetType('');
				}

				if (this.isCopySelected()) {
					var copy = this.model.clone();
					copy.setName(this.uigetName());
					copy.setDescription(this.uigetDescription());
					copy.setDashboardId(this.uigetDashboard());
					copy.unset('id');
					copy.save().then(function(saved) {
						self.navigateTo('/domains/' + copy.getDomainId() + '/reports/' + saved.id);
					});
					copy.get('domain').addReport(copy.clone());
				} else {
					self.model.setName(self.uigetName());
					self.model.setDescription(self.uigetDescription());
					self.model.setDashboardId(self.uigetDashboard());
					self.model.save().then(function(saved) {
						self.model.set('saveInProgress', false, {
							silent: true
						});
						if (imported) {
							self.navigateTo('/domains/' + saved.domainId + '/reports/' + saved.id);
						}
						self.model.trigger('saved');
					});
				}
				dialog.close();
			}
		},

		isOwner: function() {
			var self = this;
			if (self.getDashboard()) {
				var dashboard = App.dashboards.find(function(d) {
					return d.id === self.getDashboard();
				});
				return (this.model.isOwner() && dashboard.get('dashboardType') !== 'FIXED');
			} else {
				return this.model.isOwner();
			}
		},

		hasSaveAsCopyOption: function() {
			return !this.model.isNew();
		},

		hasSaveAsSelected: function() {
			return this.selectSaveAs;
		},

		hasSaveAsWidgetOption: function() {
			return this.getAvailableWidgetType().length > 0;
		},

		hasReportWidgetType: function() {
			return !!this.model.getWidgetType() || this.reportType === 'widget';
		},

		isCopySelected: function() {
			return this.$el.find(this.ui.$copyFieldId).is(':checked');
		},

		isCopyDisabled: function() {
			return this.$el.find(this.ui.$copyFieldId).is(':disabled');
		},

		selectCopy: function() {
			return this.$el.find(this.ui.$copyFieldId).prop('checked', true);
		},

		isSaveAsWidgetSelected: function() {
			return this.$el.find(this.ui.$saveAsWidgetFieldId).is(':checked');
		},

		getIsPrivate: function() {
			return this.model.getIsPrivate();
		},

		uigetIsPrivate: function() {
			return !this.uigetIsPublic();
		},

		uigetIsPublic: function() {
			return this.$el.find(this.publicFieldId).is(':checked');
		},

		uigetDashboard: function() {
			return this.$el.find(this.ui.$selectedDashboard).val();
		},

		uisetDashboard: function(dashboard) {
			return this.$el.find(this.ui.$selectedDashboard).val(dashboard);
		},

		onChangeAsCopy: function() {
			this.isValid();
		},
		validate: function(val, field) {
			var self = this;

			// call base class isValid function
			SaveDialogView.prototype.validate.call(this, val, field);

			if (this.$el.find(this.nameFieldId).parent().hasClass('has-error')) {
				return;
			}

			var desiredName = this.uigetName();
			// check for duplicate name
			// get all report names
			var report = _.find(App.domains.models, function(domain) {
				return _.find(domain.reportCollection().models, function(r) {
					if (self.isCopySelected()) {
						if (r.isOwner() && r.get('modelName') === strings.reportModelName &&
							(r.getReportType() === undefined || r.getReportType() === reportTypes.REPORT) &&
							r.getName().trim() === desiredName.trim()) {
							return r;
						}
					} else {
						if (r.isOwner() && r.get('modelName') === strings.reportModelName &&
							(r.getReportType() === undefined || r.getReportType() === reportTypes.REPORT) &&
							r.getName().trim() === desiredName.trim() &&
							r.getId() !== self.model.getId()) {
							return r;
						}
					}
				});
			});

			if (report) {
				this.$el.find(this.nameFieldId).parent().addClass('has-error');
				this.$el.find(this.nameFieldId).parent().find('span.help-block').text('Duplicate report name');
			} else {
				this.$el.find(this.nameFieldId).parent().removeClass('has-error');
				this.$el.find(this.nameFieldId).parent().find('span.help-block').text();
			}
		}
	});

	return view;
});

